// "WHAT'S NEXT / MORE TO COME." placeholder tile in the Skin & Beauty
// mustard accent. Used wherever a program grid wants to communicate
// "more programs are coming" — Landing, in-app PreSelectionHome,
// in-app Browse. The tile auto-balances the grid: pass `forceWide` to
// span both desktop columns (e.g. when the surrounding count is even
// and we want the placeholder to finish the row flush).
import { Link } from "react-router-dom";

export default function WhatsNextTile({
  to = "/what-we-help-with",
  forceWide = false,
  compact = false,
  testId = "program-panel-whats-next",
}) {
  // `compact` mirrors ProgramColorTile's sizing (32px padding, 260
  // minHeight) so the yellow tile sits flush in member-shell grids
  // alongside ProgramColorTiles. Default sizing matches the larger
  // Landing tiles. The grid's default `align-items: stretch` does the
  // rest — all cells in a row come out equal-height.
  const padding = compact ? "32px 28px" : "56px 40px 64px";
  const minHeight = compact ? 260 : 280;
  const numberSize = compact ? "clamp(40px, 6vw, 64px)" : "clamp(48px, 7vw, 78px)";
  const titleSize = compact ? 30 : 38;
  const taglineSize = compact ? 18 : 22;
  return (
    <Link
      to={to}
      data-testid={testId}
      className={forceWide ? "md:!col-span-2" : ""}
      style={{
        background: "#D4B848",
        color: "#3A2F0E",
        padding,
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        minHeight,
        position: "relative",
        overflow: "hidden",
        transition: "transform 200ms ease",
        textDecoration: "none",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
    >
      <span
        aria-hidden
        style={{
          position: "absolute",
          top: 24,
          right: 20,
          zIndex: 1,
          fontFamily: '"Instrument Serif", Georgia, serif',
          fontStyle: "italic",
          fontSize: numberSize,
          lineHeight: 1,
          opacity: 0.5,
          color: "#7A6320",
          pointerEvents: "none",
          letterSpacing: "-0.04em",
          paddingRight: 8,
        }}
      >
        ★
      </span>
      <div style={{ position: "relative", zIndex: 2, maxWidth: 720, display: "flex", flexDirection: "column", flex: 1 }}>
        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.2em", color: "#7A6320", opacity: 0.95 }}>
          WHAT'S NEXT
        </div>
        <div style={{ marginTop: compact ? 16 : 22, fontSize: titleSize, fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 1, color: "#3A2F0E", textTransform: "uppercase", maxWidth: "84%" }}>
          MORE TO COME.
        </div>
        <div style={{ marginTop: compact ? 12 : 16, fontFamily: '"Instrument Serif", serif', fontStyle: "italic", fontSize: taglineSize, color: "#7A6320" }}>
          "Programs we’re building carefully."
        </div>
        <div style={{ marginTop: "auto", paddingTop: compact ? 18 : 28, fontSize: 11, fontWeight: 800, letterSpacing: "0.2em", color: "#7A6320" }}>
          SEE WHAT WE HELP WITH →
        </div>
      </div>
    </Link>
  );
}
